export const normalizeBetaSidebarReference = (frameType?: string | null) => {
    const normalizedFrameType = String(frameType ?? '').toLowerCase()

    switch (normalizedFrameType) {
        case 'title':
            return 'title'
        case 'text':
            return 'text'
        case 'container':
            return 'container'
        case 'image':
            return 'image'
        case 'button':
            return 'button'
        case 'beforeafterimage':
        case 'before-after-image':
        case 'before_after_image':
            return 'beforeAfterImage'
        case 'form':
            return 'form'
        case 'row':
            return 'row'
        case 'gallery':
            return 'gallery'
        default:
            return 'default'
    }
}
